import { getJobResponse } from "../../../Actions/API/Job/JobActions"
import { JobResponseModel, JobStatus } from "../../../Models/API/JobModel"
import { createProvider } from "../Common/Provider"
import { hasValue, FetchState } from "../../../Models/Client/FetchState"

interface JobOutputProviderProps {
    appID: string
    jobID: string
}

export const JobOutputProvider = createProvider<
    FetchState<JobResponseModel>,
    JobOutputProviderProps
>(
    (state, { jobID }) => state.api.jobs.outputs[jobID],
    ({ jobID }) => getJobResponse(jobID),
    (state, { jobID, appID }) => {
        // attempt to fetch only if job is already fetched and its state is COMPLETED
        const jobs = state.api.jobs.table[appID]
        const output = state.api.jobs.outputs[jobID]

        if (output !== undefined || jobs === undefined) {
            return false
        }

        const record = jobs.records.get(jobID)

        return hasValue(record) && record.value.status === JobStatus.COMPLETED
    }
)
